import axios from 'axios';

export function getVessel() {
  return axios.get('/api/?entity=vessel&action=getVessel').then(response => response.data && response.data.data);
}
